export default __webpack_public_path__ + "static/gitlab-4efdbb1df4fbce23b88b616a4296d2d2.svg";